import { useState } from "react";
import { toast } from "sonner";
import { Export, FileXls, FilePdf, FileCsv, CircleNotch } from "@phosphor-icons/react";
import { downloadExport, errMsg } from "@/lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const OPTIONS = [
  ["xlsx", "Excel workbook (.xlsx)", FileXls, "text-emerald-700"],
  ["pdf", "PDF report", FilePdf, "text-rose-600"],
  ["csv", "CSV file", FileCsv, "text-slate-600"],
];

export function ExportMenu({ projectId, beforeExport }) {
  const [busy, setBusy] = useState(false);
  const run = async (fmt) => {
    setBusy(true);
    try {
      await beforeExport();
      await downloadExport(projectId, fmt);
      toast.success("Report downloaded");
    } catch (e) {
      toast.error(errMsg(e, "Export failed"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="export-menu-button" disabled={busy}
          className="inline-flex items-center gap-2 h-10 px-4 bg-slate-900 text-white text-sm font-medium rounded-sm hover:bg-slate-800 transition-colors shadow-sm disabled:opacity-60 self-start lg:self-auto">
          {busy ? <CircleNotch className="animate-spin" size={16} /> : <Export size={16} weight="bold" />} Export Report
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        {OPTIONS.map(([fmt, label, Icon, cls]) => (
          <DropdownMenuItem key={fmt} data-testid={`export-${fmt}`} onClick={() => run(fmt)}>
            <Icon size={18} weight="duotone" className={`mr-2 ${cls}`} /> {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
